import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { Guid, isNotNil } from '@web/utils';
import { toObservable } from '@angular/core/rxjs-interop';
import { Observable, switchMap } from 'rxjs';
import { WarehouseReceiptDataSourceService } from '../../services/warehouse-receipt-data-source.service';
import { WarehouseReceiptDetails } from '../../models/warehouse-receipt-details';
import { DetailsViewComponent, SpinnerFilledComponent } from '@web/shared/ui';
import { WarehouseReceiptProductDetailsAttributesComponent } from '../../components/warehouse-receipt-product-details-attributes/warehouse-receipt-product-details-attributes.component';
import { WarehouseReceiptDetailsAttributesComponent } from '../../components/warehouse-receipt-details-attributes/warehouse-receipt-details-attributes.component';
import { AccordionModule } from 'primeng/accordion';
import { GalleriaModule } from 'primeng/galleria';
import { MultimediaGalleriaThumbnailsComponent } from '@web/shared/module/multimedia';
import { WarehouseMultimediaDataSourceService } from '../../services/warehouse-multimedia-data-source.service';

@Component({
  selector: 'app-warehouse-receipt-details',
  imports: [
    AccordionModule,
    CommonModule,
    DetailsViewComponent,
    GalleriaModule,
    MultimediaGalleriaThumbnailsComponent,
    SpinnerFilledComponent,
    WarehouseReceiptDetailsAttributesComponent,
    WarehouseReceiptProductDetailsAttributesComponent,
  ],
  templateUrl: './warehouse-receipt-details.component.html',
  styleUrl: './warehouse-receipt-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReceiptDetailsComponent {
  /* prettier-ignore */
  private readonly warehouseReceiptDataSource = inject(WarehouseReceiptDataSourceService);
  /* prettier-ignore */
  private readonly warehouseMultimediaDataSource = inject(WarehouseMultimediaDataSourceService);

  public readonly thumbnailsVisibility = input(false);
  public readonly id = input.required<Guid>();

  protected readonly id$ = toObservable(this.id);
  protected readonly details$ = this.detailsSource();
  protected readonly isNotNil = isNotNil;

  /* prettier-ignore */
  protected readonly fetchMultimediaDetailsFn = (id: Guid) => this.warehouseMultimediaDataSource.fetchDetailsById(id, true);

  private detailsSource(): Observable<WarehouseReceiptDetails> {
    return this.id$.pipe(
      switchMap((id) => this.warehouseReceiptDataSource.fetchDetailsById(id)),
    );
  }
}
